<template>
  <v-row justify="center" class="flex-wrap border-8">
    <v-dialog
      width="550px"
      max-width="85%"
      class="border-8"
      transition="dialog-bottom-transition"
      scrollable
      persistent
      v-model="dialog"
      @keydown.esc="onCancel"
    >
      <v-card class="border-8 px-4j">
        <v-row no-gutters class="justify-center align-center text-center">
          <v-col cols="12">
            <v-img
              v-if="type === 'delete' || type === 'notice'"
              class="mx-auto mt-8"
              :src="warningCloseIcon"
              width="100"
              height="100"
            ></v-img>
            <v-img v-else class="mx-auto mt-8" :src="warningIcon" width="100" height="100"></v-img>
            <p class="fs-bold-28 mt-5" v-html="title"></p>
            <p
              class="fs-bold-20"
              :style="type === 'notice' ? 'color: #FF5252' : 'color: #4a4d51'"
              v-html="subTitle"
            ></p>
            <div v-if="isShowSendNoti" class="d-flex justify-center align-center mt-1">
              <v-checkbox
                hide-details
                v-model="isSendNotification"
                style="margin-top: 0 !important; padding-top: 0 !important"
              />
              <p class="fs-bold-20 justify-center align-center">คุณต้องการแจ้งเตือน อีเวนต์ นี้หรือไม่ ?</p>
            </div>
            <div v-if="isCheckboxConfirmSubmit" class="d-flex justify-center align-center mt-1">
              <v-checkbox
                hide-details
                v-model="isCheckedSubmit"
                style="margin-top: 0 !important; padding-top: 0 !important"
              />
              <p class="fs-bold-20 justify-center align-center">{{ checkboxConfirmSubmitLabel }}</p>
            </div>
          </v-col>
        </v-row>
        <v-footer dark padless color="white" class="d-flex justify-center align-center text-center mb-8 mt-4">
          <v-card-actions>
            <template v-if="isOnlyConfirm">
              <v-btn @click="onCancel" color="#1976D2" outlined width="148"> ตกลง</v-btn>
            </template>
            <template v-else>
              <v-btn @click="onCancel" color="#1976D2" outlined width="148" class="mr-6">
                {{ type === 'delete' ? 'กลับ' : 'ยกเลิก' }}</v-btn
              >
              <v-btn :disabled="isCheckboxConfirmSubmit && !isCheckedSubmit" @click="onSubmit" :color="type === 'delete' ? '#FF5252' : '#1976D2'" width="148"> ยืนยัน </v-btn>
            </template>
          </v-card-actions>
        </v-footer>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import warningIcon from '@/assets/icons/warning_icon2.png';
import trashIcon from '@/assets/icons/trash_icon.png';
import warningCloseIcon from '@/assets/icons/warning_icon.png';

export default {
  components: {},
  props: {
    isShowConfirmModal: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    subTitle: {
      type: String,
    },
    isShowSendNoti: {
      ttype: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: null,
    },
    isOnlyConfirm: {
      type: Boolean,
      default: false,
    },
    isCheckboxConfirmSubmit: {
      type: Boolean,
      default: false,
    },
    checkboxConfirmSubmitLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: true,
      titleTh: '',
      titleEn: '',
      detailTh: '',
      detailEn: '',
      imageUrlTh: null,
      imageUrlEn: null,
      updatedAt: '-',
      updatedBy: '-',
      warningIcon,
      trashIcon,
      warningCloseIcon,
      isSendNotification: false,
      isCheckedSubmit: false,
    };
  },
  created() {
    console.log('on created');
    this.dialog = this.isShowConfirmModal;
  },
  methods: {
    onCancel() {
      this.$emit('cancelled');
    },
    onSubmit() {
      this.$emit('saved', this.isSendNotification);
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0px !important;
}

.v-sheet.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: none !important;
  border-bottom: 1px solid #d1d1d1 !important;
}

.text-black {
  color: black;
}

.text-secondary {
  color: #747474;
}

.fs-bold-28 {
  font-size: 28px !important;
  font-weight: 500 !important;
}

.fs-bold-20 {
  font-size: 20px !important;
  font-weight: 500 !important;
}

.border-4 {
  border-radius: 4px !important;
}

.border-8 {
  border-radius: 8px !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #D7D8D9 !important;
  color: #A2A4A7 !important;
}
</style>
